import React, { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { SizeOptionProps, commonDetailsForSize, sizeDetailsForSizeOption } from '../../../../lib/size';
import styles from './SizeOptionDetails.module.scss';

export interface SizeOptionButtonProps extends SizeOptionProps {
  sizeOptionRef?: MutableRefObject<HTMLDivElement | null>;
}

export default function SizeOptionButton(props: SizeOptionButtonProps) {
  const { t } = useTranslation();
  const sizeDetails = sizeDetailsForSizeOption(props);

  if (!sizeDetails) {
    const commonDetails = commonDetailsForSize(props.sizeOption);
    return (
      <div className={styles.container} ref={props.sizeOptionRef}>
        <div className={styles.sizeName}>{commonDetails.sizeName}</div>
        <div className={styles.sizeDescription}>
          <div>{t('not_offered_by_this_maker')}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container} ref={props.sizeOptionRef}>
      <div className={styles.sizeName}>{sizeDetails.sizeName}</div>
      <div className={styles.sizeDescription}>
        <div>{sizeDetails.neckSize}</div>
        <div>{t('band_width_wide_collar', { bandWidth: sizeDetails.bandWidth })}</div>
      </div>
    </div>
  );
}
